export default __webpack_public_path__ + "static/media/ArrowRightSkinnyIcon.ebcf416c.svg";